// src/utils/environment.js

/**
 * Detecta si la aplicación está ejecutándose en un entorno de desarrollo (localhost)
 * @returns {boolean} true si está en desarrollo, false si está en producción
 */
export const isLocalhost = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('localhost');
};

/**
 * Detecta si la aplicación está ejecutándose en producción
 * @returns {boolean} true si está en producción, false si está en desarrollo
 */
export const isProduction = () => {
  return !isLocalhost();
};
